module.exports = __webpack_public_path__ + "img/NanumSquareOTFB.7bb63dab.svg";